import request from '@/utils/request'


// 查询首页logo列表
export function listLogo(query) {
  return request({
    url: '/logo/logo/list',
    method: 'get',
    params: query
  })
}

// 查询首页logo分页
export function pageLogo(query) {
  return request({
    url: '/logo/logo/page',
    method: 'get',
    params: query
  })
}

// 查询首页logo详细
export function getLogo(data) {
  return request({
    url: '/logo/logo/detail',
    method: 'get',
    params: data
  })
}

// 新增首页logo
export function addLogo(data) {
  return request({
    url: '/logo/logo/add',
    method: 'post',
    data: data
  })
}

// 修改首页logo
export function updateLogo(data) {
  return request({
    url: '/logo/logo/edit',
    method: 'post',
    data: data
  })
}

// 删除首页logo
export function delLogo(data) {
  return request({
    url: '/logo/logo/delete',
    method: 'post',
    data: data
  })
}
